import { Select, Display, DisplayMoney } from "../../workspace";
import { useAppContext } from "../../../context/appContext";
import { calcTotalCost } from "../../../utils/calcCost";
import { moneyToNumber } from "../../../utils/money";

const Costs = ({ editingItem }) => {
  // console.log('Glazing editingItem:', editingItem)
  const { job, customer, prices, lists } = useAppContext();
  const {
    cost_retail,
    cost_materials,
    cost_labor,
    quantity,
    unitPrice,
    labor_cost,
    custom_price,
  } = editingItem;
  
  const customPrice = moneyToNumber(custom_price);

  console.log("custom_price:", custom_price)

  let price = customPrice // if custom price
    ? customPrice // use custom price
    : unitPrice; // else calculate price
  // const ttlPrice = unitPrice * quantity;
 
  const { tax, laborTotalCost, totalCost, profit } = calcTotalCost(
    cost_retail,
    cost_materials,
    cost_labor,
    labor_cost,
    price
  );


  const totalProfit = profit * quantity;


  return (
    <div className="one-fourth">
      <Display name="Man Hours" value={cost_labor} />
      <DisplayMoney name="Labor Cost" value={laborTotalCost} />
      <DisplayMoney name="Materials Cost" value={cost_materials} />
      <DisplayMoney name="Tax" value={tax} />
      <DisplayMoney name="Unit Cost" value={totalCost} />
      <DisplayMoney name="Unit Profit" value={profit} />
      <div className="bold">
        <DisplayMoney name="Total Profit" value={totalProfit} />
      </div>
    </div>
  );
};
export default Costs;
